<script lang="ts" setup>
  import {computed} from 'vue';
  import useCpBem from '~/composables/useCpBem';
  import CpSectionHeader from '~/components/cp/CpSection/CpSectionHeader/CpSectionHeader.vue';
  import CpSectionStrip from '~/components/cp/CpSection/CpSectionStrip/CpSectionStrip.vue';
  import type {ICpArticle} from '~/types';

  const props = defineProps<{
    title: string
    buttonLabel: string
    itemsToShow: ICpArticle[]
  }>();
  const goToHistory = () => {
    navigateTo(useCpNavigateToParams('view-history'));
  };
  defineEmits({

  });

  const showButton = computed(() => props.itemsToShow.length > 6);

  const {b} = useCpBem('cp-section-home-view-history');
</script>
<template>
    <div :class="b">
        <CpSectionHeader :title="title" type="h2" show-top-border />
        <CpSectionStrip
            :button="showButton"
            :items-to-show="itemsToShow"
            kind="cta6"
            card-type="home"
            :label="buttonLabel"
            @button-press="goToHistory"
        />
    </div>
</template>
<style scoped lang="scss">
  .cp-section-home-view-history {
    display: flex;
    flex-direction: column;
  }
</style>
